import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import styles from './styles.less';

const BlogSubscribe = ({ cat, onSelect }) => {
  const [state, setState] = React.useState(false);
  const { CheckableTag } = Tag;

  const handleChange = e => {
    setState(e);
    onSelect(e);
  };

  return (
    <div>
      <CheckableTag
        value={cat}
        checked={state}
        onChange={handleChange}
        className={styles.checkable}
      >
        {cat}
      </CheckableTag>
    </div>
  );
};

BlogSubscribe.propTypes = {
  cat: PropTypes.string,
  onSelect: PropTypes.func,
};

BlogSubscribe.defaultProps = {
  cat: '',
  onSelect: () => {},
};

export default BlogSubscribe;
